import React from 'react';
import { useObserver } from 'mobx-react-lite';

import useUser from 'src/hooks/use-user';

import { PersonalizedProductsQuery } from 'src/personalization/data-layer/types';

import { LoggedInV2 } from './logged-in-v2';

type PersonalizedProductsProps = {
  personalizedProductsQuery: PersonalizedProductsQuery;
};

export const PersonalizedProducts = (props: PersonalizedProductsProps): JSX.Element | null => {
  const user = useUser();
  const isLoggedIn = useObserver(() => user.isLoggedIn);

  const { personalizedProductsQuery } = props;
  const { data, loading } = personalizedProductsQuery;
  const hasNoProducts = !data?.getPersonalizedProducts?.products.length;

  if (!loading && hasNoProducts) {
    return null;
  }

  // The logged-out CTA lives a level up (LoginCta on the home pages); this carousel is
  // logged-in only.
  if (!isLoggedIn) {
    return null;
  }

  return (
    <div data-testid='personalized-products'>
      <LoggedInV2 personalizedProductsQuery={personalizedProductsQuery} />
    </div>
  );
};
